<template>
  <base-layout redirectTo="home">
    <sucess-recover-message @continue="handleRedirect" @finish="finish" v-if="showFinishScreen"/>
    <v-container class="new-password" fluid v-else>
      <v-row class="mb-4" no-gutters>
        <v-col>
          <p class="new-password-title" :style="{ color: getAssets.colors.form.buttonBackground }">Redefina sua senha</p>
          <p class="new-password-subtitle">Agora basta digitar e confirmar sua senha. Recomendamos que sua senha tenha números, letras maiúsculas e minúsculas. Mas você pode fazer como preferir, a senha <strong> só deve ter no mínimo 6 caracteres</strong>, ok?</p>
        </v-col>
      </v-row>
      <v-row class="mb-2" no-gutters>
        <v-text-field
          outlined
          :type="showPassword ? 'text' : 'password'"
          label="Digite sua nova senha"
          v-model="password"
          :error-messages="errorPassword"
          @input="errorPassword = ''"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
        />
      </v-row>
      <v-row class="mb-2" no-gutters>
        <v-text-field
          outlined
          :type="showPasswordConfirm ? 'text' : 'password'"
          label="Confirme sua nova senha"
          v-model="passwordConfirm"
          :error-messages="errorPasswordConfirm"
          @input="errorPasswordConfirm = ''"
          :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPasswordConfirm = !showPasswordConfirm"
        />
      </v-row>
      <v-row no-gutters>
        <v-btn width="100%" class="button-height" :color="getAssets.colors.form.buttonBackground" :style="{ color: getAssets.colors.form.buttonFont }" :loading="btnLoading" @click="submit" :disabled="!password || !passwordConfirm">redefinir senha</v-btn>
      </v-row>
      <v-snackbar left v-model="snackbarError">
      Ocorreu um erro. Tente novamente mais tarde
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbarError = false">
            fechar
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </base-layout>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  data: () => ({
    password: '',
    passwordConfirm: '',
    showPassword: '',
    showPasswordConfirm: '',
    errorPassword: '',
    errorPasswordConfirm: '',
    btnLoading: false,
    snackbarError: false,
    token: null,
    cpfCnpj: '',
    showFinishScreen: false
  }),
  components: {
    BaseLayout: () => import('@/components/layout/BaseLayout.vue'),
    SucessRecoverMessage: () => import('@/modules/users/views/components/SuccessRecoverMessage.vue')
  },
  methods: {
    ...mapMutations(['IS_RECOVER_SMS']),
    redirect(route, value) {
      const cpfCnpj = value.length === 11 ? 'cpf' : 'cnpj'
      this.$router.push({
        path: route,
        query: { [cpfCnpj]: value }
      })
    },
    submit() {
      if (!this.password) {
        this.errorPassword = 'Este campo é obrigatório'
        return
      }

      if (!this.passwordConfirm) {
        this.errorPasswordConfirm = 'Este campo é obrigatório'
        return
      }

      if (this.password.length < 6 || this.passwordConfirm.length < 6) {
        this.errorPassword = this.password.length < 6 ? 'Esse campo precisa ter pelo menos 6 caracteres.' : ''
        this.errorPasswordConfirm = this.passwordConfirm.length < 6 ? 'Esse campo precisa ter pelo menos 6 caracteres.' : ''
        return
      }

      if (this.password !== this.passwordConfirm) {
        this.errorPassword = 'As senhas não são iguais'
        this.errorPasswordConfirm = 'As senhas não são iguais'
        return
      }

      if (!this.isSmsRecover && !this.$route.query.token) {
        this.snackbarError = true
        return
      }

      this.btnLoading = true
      this.$store.dispatch(this.isSmsRecover ? 'resetPasswordBySms' : 'resetPassword', {
        password: this.password,
        token: this.isSmsRecover ? null : this.$route.query.token
      })
        .then((cpfCnpj) => {
          if (cpfCnpj) this.cpfCnpj = cpfCnpj
          this.showFinishScreen = true
          this.IS_RECOVER_SMS(false)
        }).catch((err) => {
          console.log(err)
          this.snackbarError = true
        }).finally(() => {
          this.btnLoading = false
        })
    },
    handleRedirect () {
      this.redirect('cadastro', this.userCpfCnpj)
    },
    finish () {
      this.$router.push('/')
    }
  },
  computed: {
    getAssets() {
      return this.$store.getters.GET_ASSETS
    },
    userCpfCnpj() {
      if (this.cpfCnpj) return this.cpfCnpj
      return this.$store.getters.USER_INFO.document_no
    },
    isSmsRecover() {
      return this.$store.getters.IS_RECOVER_SMS
    }
  },
  mounted() {
    // token validation called at App.vue
    if (!this.isSmsRecover && !this.$route.query.token) {
      this.$router.push({ path: '/home' })
    }
  }

}
</script>

<style lang="scss">
$phone-size: 600px;

.new-password {
  padding: 40px 30px;
  text-align: center;

  p {
    margin-bottom: 10px;
  }

  &-title {
    font-size: 32px;
    font-weight: 500;
  }

  &-subtitle {
    font-size: 14px;
    color: #6B7580;
  }

  .v-input__slot {
    margin-bottom: 0px !important;
  }
}

@media screen and (min-width: $phone-size) {
  .new-password {
    text-align: left;

    &-subtitle {
      margin: 0 0 30px;
    }
  }
}
</style>
